import React, {useCallback, useEffect, useState} from "react";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Snackbar
} from "@material-ui/core";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {MUIInput, MUIMultiSelect, MUISelect, MUISwitch} from "../../utils/formUtils";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import addressData from "../../data/addressData.json";
import Stack from "@mui/material/Stack";
import InfoIcon from '@mui/icons-material/Info';
import {styled} from "@material-ui/styles";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {Alert} from "@material-ui/lab";
import _ from "underscore";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

yup.addMethod(yup.string, 'simpleCheck', function(errorMessage) {
    return this.test('alpha', errorMessage, function (value) {return value === null || value === undefined || value === '' || !isNaN(value)})
});

const validationSchema = yup.object().shape({
    searchName: yup.string().required('Name required.').nullable(),
    coverageAMax: yup.string().simpleCheck('Maximum Property Value should be a number').nullable()    ,
    coverageAMin: yup.string().simpleCheck('Minimum Property Value should be a number').nullable(),
    earliestYearBuild: yup.string().simpleCheck('Year built should be a number').nullable(),
    sqrFootageMin: yup.string().simpleCheck('Square Footage should be a number').nullable(),
    sqrFootageMax: yup.string().simpleCheck('Square Footage should be a number').nullable(),
});

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

const initState = {
    coverageAMax: undefined,
    searchName: undefined,
    coverageAMin: undefined,
    earliestYearBuild: undefined,
    sqrFootageMin: undefined,
    sqrFootageMax: undefined,
    claimCount: "100",
    offerCoverageWithPool: true,
    offerCoverageToFireHydrantWithing1000Ft: false,
    offerCoverageToFireStationMorethan5Mi: false,
    offerCoverageToOwnerOfExoticAnimals: true,
    offerCoverageToDogBreed: true,
    offerCoverageToFarmingOrBusiness: true,
    acceptableDistanceToSaltWater: -1,
    roofUpdates: 0,
    electricalUpdates: 0,
    hvacUpdates: 0,
    filterLocation: 'FL',
    searchId: undefined,
    agentId:undefined,
    acceptableZipCodes: [],
    acceptableCounties: [],
    acceptedPropertyTypes: [],
    acceptedConstructionTypes: [],
    acceptedPropertyUsages: [],
    acceptedOccupiedBy: [],
    status : 'Active'
};

export default function AgentSearchCriteriaCreateTile({criteriaId, agenId, setShowEditTile, getAllSearchCriteria, showMessageAfterReturnFromChild}) {
    const {
        handleSubmit,
        control,
        trigger,
        formState: {errors},
        watch
    } = useForm({resolver: yupResolver(validationSchema)});
    const [searchCriteria, setSearchCriteria] = useState(Object.assign({}, initState,{agentId:agenId}));
    const [propertyTypeList, setPropertyTypeList] = useState([]);
    const [constructionTypeList, setConstructionTypeList] = useState([]);
    const [usageList, setUsageList] = useState([]);
    const [yearSpanList, setYearSpanList] = useState([]);
    const [occupancyList, setOccupancyList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    const [combinedZip, setCombinedZip] = useState(null);
    const [zipError, setZipError] = useState(null);
    const [disToCoastList, setDisToCoastList] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState(null);
    const [openSnackBarError, setOpenSnackBarError] = useState(false);
    const [previousState, setPreviousState] = useState({});
    const watchedValues = watch();
    const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
    const fetchCriteriaBasedOnId = useCallback(() => {
        if (!_.isEmpty(usageList)) {
            setShowSpinner(true);
            axiosInstance.post('search/get-search-critieria', {searchId: criteriaId, agentId : agenId})
                .then((data) => {
                    if (data && data.resultList && data.resultList.length > 0) setSearchCriteriaFromAPI(data.resultList[0]);
                })
                .catch((error) => {
                    setOpenSnackBar(false);
                    setOpenSnackBarError(true);
                    setSnackBarMessage('An error occurred while retrieving the Search Criteria. Please try again later.');
                })
                .finally(() => setShowSpinner(false));
        }
    }, [axiosInstance, usageList, propertyTypeList,constructionTypeList, disToCoastList, yearSpanList]);

    useEffect(() => {

        if (previousState && searchCriteria && searchCriteria['searchName'] && previousState['searchName']) {
            let isDirty = false;
            let isFilterCriteriaMet = false;
            if (searchCriteria.filterLocation === 'County') {
                if (searchCriteria.acceptableCounties.length > 0) {
                    isFilterCriteriaMet = true;
                }
            } else if (searchCriteria.filterLocation === 'Zip') {
                if (searchCriteria.acceptableZipCodes.length > 0) {
                    isFilterCriteriaMet = true;
                }
            } else if (searchCriteria.filterLocation === 'FL') {
                isFilterCriteriaMet = true;
            }

            if (isFilterCriteriaMet) {
                if (searchCriteria.filterLocation === 'County') {
                    if (previousState.filterLocation === 'County') {
                        if (!arraysAreEqual(searchCriteria.acceptableCounties, previousState.acceptableCounties)) {
                            console.log('failed at acceptableCounties');
                            isDirty = true;
                        }
                    } else {
                        isDirty = true;
                    }
                } else if (searchCriteria.filterLocation === 'Zip') {
                    if (previousState.filterLocation === 'Zip') {
                        if (!arraysAreEqual(searchCriteria.acceptableZipCodes, previousState.acceptableZipCodes)) {
                            console.log('Failed at acceptableZipCodes');
                            isDirty = true;
                        }
                    } else {
                        isDirty = true;
                    }
                } else if (searchCriteria.filterLocation !== previousState.filterLocation) {
                    isDirty = true;
                }
            }

            if (isFilterCriteriaMet && !isDirty) {
                for (const key of Object.keys(previousState)) {
                    if (['acceptableZipCodes', 'acceptableCounties'].includes(key)) {
                        continue;
                    }
                    if ('claimCount' === key) {
                        const claimCountNumber = Number(searchCriteria[key]);
                        if (previousState[key] !== claimCountNumber) {
                            console.log('Failed at ', key);
                            isDirty = true;
                            break;
                        }
                        continue;
                    }

                    if (typeof previousState[key] === 'boolean' && typeof searchCriteria[key] === 'boolean') {
                        if (previousState[key] !== searchCriteria[key]) {
                            console.log('Failed at ', key);
                            isDirty = true;
                            break;
                        }
                    } else if (previousState[key] && searchCriteria[key]) {
                        if (typeof previousState[key] === 'object' && Array.isArray(previousState[key])) {
                            if (Array.isArray(searchCriteria[key]) &&
                                (!arraysAreEqual(previousState[key], searchCriteria[key]))) {
                                console.log('Failed at ', key);
                                isDirty = true;
                                break;
                            }
                        } else {
                            if (_.isNumber(previousState[key])) {
                                const validNumber = Number(searchCriteria[key]);
                                if (isNaN(validNumber) || previousState[key] !== validNumber) {
                                    console.log('Failed at ', key);
                                    isDirty = true;
                                    break;
                                }
                            } else if (previousState[key] !== searchCriteria[key]) {
                                console.log('Failed at ', key);
                                isDirty = true;
                                break;
                            }
                        }
                    } else if ((checkForEmpty(previousState[key]) && !checkForEmpty(searchCriteria[key])) ||
                        (!checkForEmpty(previousState[key]) && checkForEmpty(searchCriteria[key]))) {
                        console.log('Failed at ', key);
                        isDirty = true;
                        break;
                    }
                }
            }
            setIsUpdateDisabled(!isDirty);
        }
    }, [searchCriteria]);

    function arraysAreEqual(array1, array2) {
        if (array1.length !== array2.length) {
            return false;
        }
        for (let i = 0; i < array1.length; i++) {
            // If any elements are not equal, return false
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
    }

    function checkForEmpty(value) {
        return value === undefined || value === '' || value === null;
    }

    useEffect(() => {
        if (criteriaId) {
            fetchCriteriaBasedOnId();
        } else {
            setSearchCriteria(Object.assign({},initState, {agentId: agenId}));
        }
    },[criteriaId, fetchCriteriaBasedOnId]);

    useEffect(() => {
        setSearchCriteria(Object.assign({}, searchCriteria, {agentId : agenId}));
    }, [agenId]);


    const setSearchCriteriaFromAPI = (data) => {
        // need to convert the value to labels and update the state
        let filterOption = 'FL'; let selectedCounty = []; let selectedZip = [];
        if (!_.isEmpty(data.acceptableCounties)) {
            filterOption = 'County'
        }
        if (data.acceptableZipCodes && data.acceptableZipCodes.length > 0 ) filterOption = 'Zip';

        let propertyUsages = [];
        if (!_.isEmpty(data.acceptedPropertyUsageTypeListAsString) && !_.isEmpty(usageList)) {
            data.acceptedPropertyUsageTypeListAsString.forEach(x => {
                    let usage = usageList.filter(z => z.value === x);
                    if (usage && usage.length > 0) {
                        propertyUsages.push(usage[0].value);
                    }
                }
            )
        }

        let propertyTypes = [];
        if (!_.isEmpty(data.acceptedPropertyTypeListAsString) && !_.isEmpty(propertyTypeList)) {
            data.acceptedPropertyTypeListAsString.forEach(x => {
                let type = propertyTypeList.filter(z => z.value === x);
                if (type && type.length > 0) {
                    propertyTypes.push(type[0].value)
                }
            });
        }
        let constructionTypes = [];
        if (!_.isEmpty(data.acceptedConstructionTypeListAsString) && !_.isEmpty(constructionTypeList)) {
            data.acceptedConstructionTypeListAsString.forEach(x => {
                let type = constructionTypeList.filter(z => z.value === x);
                if (type && type.length > 0) {
                    constructionTypes.push(type[0].value);
                }
            });
        }

        let searchCriteriaObj = {
            coverageAMax: (_.isNull(data?.coverageAMax)) ? undefined : data?.coverageAMax,
            searchName: data?.searchName,
            coverageAMin: (_.isNull(data?.coverageAMin)) ? undefined : data?.coverageAMin,
            searchId: data?.searchId,
            earliestYearBuild: (_.isNull(data?.earliestYearBuild)) ? undefined : data?.earliestYearBuild,
            sqrFootageMin: (_.isNull(data?.sqrFootageMin)) ? undefined : data?.sqrFootageMin,
            sqrFootageMax: (_.isNull(data?.sqrFootageMax)) ? undefined : data?.sqrFootageMax,
            claimCount: _.isNumber(data?.claimCount) ? data?.claimCount : 100,
            offerCoverageWithPool: !!data?.offerCoverageWithPool,
            offerCoverageToFireHydrantWithing1000Ft: !!data?.offerCoverageToFireHydrantWithing1000Ft,
            offerCoverageToFireStationMorethan5Mi: !!data.offerCoverageToFireStationMorethan5Mi,
            offerCoverageToOwnerOfExoticAnimals: !!data?.offerCoverageToOwnerOfExoticAnimals,
            offerCoverageToDogBreed: !!data?.offerCoverageToDogBreed,
            offerCoverageToFarmingOrBusiness: !!data?.offerCoverageToFarmingOrBusiness,
            acceptableDistanceToSaltWater: (data?.acceptableDistanceToSaltWater) ? data?.acceptableDistanceToSaltWater : -1,
            roofUpdates: (data?.roofUpdates) ? data?.roofUpdates : 0,
            electricalUpdates: (data?.electricalUpdates) ? data?.electricalUpdates : 0,
            hvacUpdates: (data?.hvacUpdates) ? data?.hvacUpdates : 0,
            filterLocation: filterOption,
            agentId: agenId,
            acceptedPropertyTypes: propertyTypes,
            acceptedConstructionTypes: constructionTypes,
            acceptedPropertyUsages: propertyUsages,
            acceptableZipCodes: [...data?.acceptableZipCodes],
            acceptableCounties: [...data?.acceptableCounties],
            acceptedOccupiedBy: [],
            status: data?.status
            // acceptableZipCodes: [...data.acceptableZipCodes],
            // acceptableCounties: [...data.acceptableCounties],
            // acceptedOccupiedBy: [...data.acceptedOccupiedBy]
        }

        let previousStateObj = {
            searchName: searchCriteriaObj.searchName,
            coverageAMin: searchCriteriaObj.coverageAMin,
            coverageAMax: searchCriteriaObj.coverageAMax,
            acceptedPropertyTypes: searchCriteriaObj.acceptedPropertyTypes,
            acceptedConstructionTypes: searchCriteriaObj.acceptedConstructionTypes,
            acceptedPropertyUsages: searchCriteriaObj.acceptedPropertyUsages,
            sqrFootageMin: searchCriteriaObj.sqrFootageMin,
            sqrFootageMax: searchCriteriaObj.sqrFootageMax,
            claimCount: searchCriteriaObj.claimCount,
            acceptableDistanceToSaltWater: searchCriteriaObj.acceptableDistanceToSaltWater,
            earliestYearBuild: searchCriteriaObj.earliestYearBuild,
            roofUpdates: searchCriteriaObj.roofUpdates,
            electricalUpdates: searchCriteriaObj.electricalUpdates,
            hvacUpdates: searchCriteriaObj.hvacUpdates,
            offerCoverageWithPool: searchCriteriaObj.offerCoverageWithPool,
            offerCoverageToFireHydrantWithing1000Ft: searchCriteriaObj.offerCoverageToFireHydrantWithing1000Ft,
            offerCoverageToFireStationMorethan5Mi: searchCriteriaObj.offerCoverageToFireStationMorethan5Mi,
            offerCoverageToOwnerOfExoticAnimals: searchCriteriaObj.offerCoverageToOwnerOfExoticAnimals,
            offerCoverageToDogBreed: searchCriteriaObj.offerCoverageToDogBreed,
            offerCoverageToFarmingOrBusiness: searchCriteriaObj.offerCoverageToFarmingOrBusiness,
            filterLocation: searchCriteriaObj.filterLocation,
            acceptableZipCodes: searchCriteriaObj.acceptableZipCodes,
            acceptableCounties: searchCriteriaObj.acceptableCounties,
        }
        setSearchCriteria(Object.assign({},searchCriteriaObj));
        setPreviousState(previousStateObj);
    };

    // loading static data when component loads
    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setPropertyTypeList(addressData.propertyType);
        setConstructionTypeList(addressData.constructionType);
        setUsageList(addressData.propertyUsageSearchCriteria);
        setOccupancyList(addressData.occupancy);
        setYearSpanList(addressData.yearSpan);
        setDisToCoastList(addressData.distanceToCoastAgent)
        setCountyList(addressData.county.map(z => {
            return {"label": z, "value": z}
        }));
    }, []);


    const handleFormChange = (event) => {
        setSearchCriteria((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
    }

    const handleFormChangeCheckbox = (event) => {
        setSearchCriteria((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.checked
        }));
    };

    const handleLocationSelect = (event) => {
        setSearchCriteria((prevState) => ({
            ...prevState,
            filterLocation: event.target.value
        }));
    };

    const addZipCode = () => {
        let zipCode = Number(combinedZip);
        if (zipCode && zipCode != NaN && zipCode >= 32003 && zipCode <= 34997) {
            if (!searchCriteria.acceptableZipCodes.includes(zipCode)) {
                setSearchCriteria((prevState) => ({
                    ...prevState,
                    acceptableZipCodes: [...searchCriteria.acceptableZipCodes, zipCode]
                }));
                setZipError(null);
                setCombinedZip('');
            }
        } else {
            setZipError('Not a valid zip code.');
        }
    }

    const removeZipCode = (zip, index) => e => {
        let zipcodes = searchCriteria?.acceptableZipCodes;
        zipcodes = zipcodes.filter((item) => item !== zip)
        setSearchCriteria((prevState) => ({
            ...prevState,
            acceptableZipCodes: [...zipcodes]
        }));
        if(zipcodes.length === 0){
            setZipError('Note: No zip is selected, default Lead By will be All of Florida.');
        }
        //updateSearchCriteria();
    }

    const onSubmit = data => {
        // to
        // add following
        // search id if exists
        // agent id

        if (additionalValidations()) return;

        // status if exists
        setShowSpinner(true);
        if (!criteriaId) createSearchCriteria();
        else updateSearchCriteria();

    };

    const nullValueCheck = (value) => value === null || value === undefined || value === '';

    const additionalValidations = () => {
        let hasError = false;
        setOpenSnackBar(false);
        setOpenSnackBarError(false);

        if ((nullValueCheck(searchCriteria.coverageAMax) && !nullValueCheck(searchCriteria.coverageAMin)) || (!nullValueCheck(searchCriteria.coverageAMax) && nullValueCheck(searchCriteria.coverageAMin))) {
            hasError = true;
            setSnackBarMessage('Minimum Property Value and Maximum Property value are needed!')
            setOpenSnackBarError(true);
        }

        if ((nullValueCheck(searchCriteria.sqrFootageMin) && !nullValueCheck(searchCriteria.sqrFootageMax)) || (!nullValueCheck(searchCriteria.sqrFootageMin) && nullValueCheck(searchCriteria.sqrFootageMax))) {
            hasError = true;
            setSnackBarMessage('Minimum Square Feet and Maximum Square Feet value are needed!')
            setOpenSnackBarError(true);
        }

        if (Number(searchCriteria.coverageAMax) <  Number(searchCriteria.coverageAMin) ) {
            hasError = true;
            setSnackBarMessage('Maximum Property Value cannot be less than Minimum Property Value.')
            setOpenSnackBarError(true);
        }

        if (Number(searchCriteria.sqrFootageMax) <  Number(searchCriteria.sqrFootageMin) ) {
            hasError = true;
            setSnackBarMessage('Maximum Square Feet cannot be less than Minimum Square Feet.')
            setOpenSnackBarError(true);
        }

        return hasError;
    }

    const getSearchCriteriaBasedOnCountyZip =() => {
        let newSearchCriteria = Object.assign({}, searchCriteria);
        if (searchCriteria.filterLocation === 'FL') {
            newSearchCriteria.acceptableZipCodes = [];
            newSearchCriteria.acceptableCounties = [];
        } else if (searchCriteria.filterLocation === 'County') {
            newSearchCriteria.acceptableZipCodes = [];
        } else if (searchCriteria.filterLocation === 'Zip') {
            newSearchCriteria.acceptableCounties = [];
        }
        setSearchCriteria({...newSearchCriteria});
        return newSearchCriteria;
    }

    const updateSearchCriteria =  () => {
        axiosInstance.post('search/update-search-critieria', getSearchCriteriaBasedOnCountyZip())
            .then((data) => {
                if (data === false) {
                    setOpenSnackBar(false);
                    setOpenSnackBarError(true);
                    setSnackBarMessage('Please enter a unique name for the Search.');
                    return
                }
                setOpenSnackBarError(false);
                setOpenSnackBar(true);
                setSnackBarMessage('Search criteria Saved!');
                setSearchCriteria(Object.assign({},initState));
                //todo SET NAVIGATIONS FROM HERE
                setShowEditTile(false);
                getAllSearchCriteria();
                showMessageAfterReturnFromChild('success', 'Search criteria Saved!');
            })
            .catch(err => {
                setOpenSnackBar(false);
                setOpenSnackBarError(true);
                setSnackBarMessage('An error occurred. Please try again later.');
            })
            .finally(() => setShowSpinner(false));
    };

    const createSearchCriteria =  () => {
        axiosInstance.post('search/save-agent-critieria', getSearchCriteriaBasedOnCountyZip())
            .then((data) => {
                if (data === false) {
                    setOpenSnackBar(false);
                    setOpenSnackBarError(true);
                    setSnackBarMessage('Please enter a unique name for the Search.');
                    return
                }

                setOpenSnackBarError(false);
                setOpenSnackBar(true);
                setSnackBarMessage('Search criteria Saved!');
                setSearchCriteria(Object.assign({},initState));
                //todo SET NAVIGATIONS FROM HERE
                setShowEditTile(false);
                getAllSearchCriteria();
                showMessageAfterReturnFromChild('success', 'Search criteria Saved!');
            })
            .catch(err => {
                setOpenSnackBar(false);
                setOpenSnackBarError(true);
                setSnackBarMessage('An error occurred. Please try again later.');
            })
            .finally(() => setShowSpinner(false));
    };
    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
        setOpenSnackBarError(false);
    };


    if (showSpinner) return <Spinner />

    return (
        <section style={{backgroundColor: "#eaeef3", paddingBottom: 30, paddingTop:5}}>
            <form
                onSubmit={handleSubmit(onSubmit)}>
                <Paper style={{margin: 16}}>
                    <Box m={2} marginBottom={0}  style={{paddingTop:15}}>
                        <Typography variant="h5" align="left" component="h2" gutterBottom>
                            Register Search Criteria <Tooltip
                            title="Please enter your search criteria. The more detail that is specified within your search criteria, the more accurate the results will be in pinpointing customers that meet your eligibility requirements. Blank entries will default to all values for a given field.  All active searches can be run real-time, or you may opt to wait for the nightly automatic search that will notify you via email if there are any consumer leads that match your requirements. Make sure to save your search criteria before exiting this screen"
                            open={showTooltip}
                            onOpen={() => setShowTooltip(true)}
                            onClose={() => setShowTooltip(false)}
                        >
                            <InfoIcon onClick={() => setShowTooltip(!showTooltip)} color="primary"/>
                        </Tooltip>
                        </Typography>
                    </Box>

                    <Box m={3}>
                        <Typography style={{marginBottom: 20}}>

                        </Typography>


                        <Grid container alignItems="flex-start" spacing={2} m={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="searchName" inputPrp={{maxLength: 20}}
                                          label="Name your search"
                                          defaultValue={searchCriteria?.searchName}
                                          value={searchCriteria?.searchName}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper style={{margin: 16}}>
                    <Box m={2} style={{paddingTop:15}}>
                        <Typography variant="h5" align="left" component="h2" gutterBottom>
                            Property Details
                        </Typography>
                    </Box>
                    <Box m={3}>
                        <Grid container alignItems="flex-start" spacing={2} m={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="coverageAMin" inputPrp={{maxLength: 14}}
                                          label="Minimum Property Value"
                                          defaultValue={searchCriteria?.coverageAMin}
                                          value={searchCriteria?.coverageAMin}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="coverageAMax" inputPrp={{maxLength: 14}}
                                          label="Maximum Property Value"
                                          defaultValue={searchCriteria?.coverageAMax}
                                          value={searchCriteria?.coverageAMax}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIMultiSelect control={control} name="acceptedPropertyTypes"
                                                value={searchCriteria?.acceptedPropertyTypes}
                                                label="Property Type" errors={errors}
                                                defaultValue={searchCriteria?.acceptedPropertyTypes}
                                                onFormChange={handleFormChange}
                                                dropdownValues={propertyTypeList}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIMultiSelect control={control} name="acceptedConstructionTypes"
                                                value={searchCriteria?.acceptedConstructionTypes}
                                                label="Construction Type" errors={errors}
                                                defaultValue={searchCriteria?.acceptedConstructionTypes}
                                                onFormChange={handleFormChange}
                                                dropdownValues={constructionTypeList}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIMultiSelect control={control} name="acceptedPropertyUsages"
                                                value={searchCriteria?.acceptedPropertyUsages}
                                                label="Use" errors={errors}
                                                defaultValue={searchCriteria?.acceptedPropertyUsages}
                                                onFormChange={handleFormChange}
                                                dropdownValues={usageList}/>
                            </Grid>
                            {/*<Grid item xs={12} sm={6} md={4}>*/}
                            {/*    <MUIMultiSelect control={control} name="acceptedOccupiedBy" value={searchCriteria?.acceptedOccupiedBy}*/}
                            {/*                    label="Occupied by" errors={errors}*/}
                            {/*                    defaultValue={searchCriteria?.acceptedOccupiedBy} onFormChange={handleFormChange}*/}
                            {/*                    dropdownValues={occupancyList}/>*/}
                            {/*</Grid>*/}
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="sqrFootageMin" inputPrp={{maxLength: 10}}
                                          label="Minimum Square Feet"
                                          defaultValue={searchCriteria?.sqrFootageMin}
                                          value={searchCriteria?.sqrFootageMin}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="sqrFootageMax" inputPrp={{maxLength: 10}}
                                          label="Maximum Square Feet"
                                          defaultValue={searchCriteria?.sqrFootageMax}
                                          value={searchCriteria?.sqrFootageMax}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISelect id="claimCount" control={control} name="claimCount" errors={errors}
                                           label="Acceptable number of homeowner/renters claims in past 3 years"
                                           defaultValue={searchCriteria?.claimCount}
                                           value={searchCriteria?.claimCount} onFormChange={handleFormChange}>
                                    {[...Array(6)].map((_, k) => {
                                        return <MenuItem key={k} value={k}>{k}</MenuItem>
                                    })}
                                    <MenuItem key="100" value="100">Does not matter</MenuItem>
                                </MUISelect>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISelect id="acceptableDistanceToSaltWater" control={control} name="acceptableDistanceToSaltWater"
                                           label="Minimum acceptable distance to salt water(miles)"
                                           errors={errors}
                                           defaultValue={searchCriteria?.acceptableDistanceToSaltWater}
                                           value={searchCriteria?.acceptableDistanceToSaltWater} onFormChange={handleFormChange}
                                           errors={errors}>
                                    <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                                    {disToCoastList.map(type => {
                                        return <MenuItem key={type?.value} value={type?.value}>{type?.label}</MenuItem>
                                    })}
                                </MUISelect>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUIInput control={control} name="earliestYearBuild" inputPrp={{maxLength: 4}}
                                          label="Earliest acceptable year built"
                                          defaultValue={searchCriteria?.earliestYearBuild}
                                          value={searchCriteria?.earliestYearBuild}
                                          onInputChange={handleFormChange} errors={errors}></MUIInput>
                            </Grid>
                            {new Date().getFullYear() - searchCriteria?.earliestYearBuild > 25 && searchCriteria?.earliestYearBuild > 999 &&
                                <>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid container alignItems="flex-start" spacing={2} m={3}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <b>Do you require updates on any of the following?</b>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <MUISelect id="roofUpdates" control={control} name="roofUpdates" errors={errors}
                                                           label="Roof Updates?"
                                                           defaultValue={searchCriteria?.roofUpdates}
                                                           value={searchCriteria?.roofUpdates} onFormChange={handleFormChange}>
                                                    {yearSpanList.map(type => {
                                                        return <MenuItem key={type?.value}
                                                                         value={type?.value}>{type?.label}</MenuItem>
                                                    })}
                                                </MUISelect>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <MUISelect id="electricalUpdates" control={control} name="electricalUpdates"
                                                           errors={errors}
                                                           label="Electrical Updates?"
                                                           defaultValue={searchCriteria?.electricalUpdates}
                                                           value={searchCriteria?.electricalUpdates}
                                                           onFormChange={handleFormChange}>
                                                    {yearSpanList.map(type => {
                                                        return <MenuItem key={type?.value}
                                                                         value={type?.value}>{type?.label}</MenuItem>
                                                    })}
                                                </MUISelect>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <MUISelect id="hvacUpdates" control={control} name="hvacUpdates" errors={errors}
                                                           label="Plumbing Updates?"
                                                           defaultValue={searchCriteria?.hvacUpdates}
                                                           value={searchCriteria?.hvacUpdates} onFormChange={handleFormChange}>
                                                    {yearSpanList.map(type => {
                                                        return <MenuItem key={type?.value}
                                                                         value={type?.value}>{type?.label}</MenuItem>
                                                    })}
                                                </MUISelect>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>}
                        </Grid>
                    </Box>
                </Paper>
                <Paper style={{margin: 16}}>
                    <Box m={2} style={{paddingTop:15}}>
                        <Typography variant="h5" align="left" component="h2" gutterBottom>
                            Additional Details
                        </Typography>
                    </Box>
                    <Box m={3}>
                        <Grid container alignItems="flex-start" spacing={2} m={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Can you provide coverage on property containing a pool?"
                                           defaultValue={searchCriteria?.offerCoverageWithPool}
                                           value={searchCriteria?.offerCoverageWithPool} name="offerCoverageWithPool"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Does the property have to be located within 1000 ft. of a fire hydrant?"
                                           defaultValue={searchCriteria?.offerCoverageToFireHydrantWithing1000Ft}
                                           value={searchCriteria?.offerCoverageToFireHydrantWithing1000Ft} name="offerCoverageToFireHydrantWithing1000Ft"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Does the property have to be located within 5 mile radius of a fire station?"
                                           defaultValue={searchCriteria?.offerCoverageToFireStationMorethan5Mi}
                                           value={searchCriteria?.offerCoverageToFireStationMorethan5Mi} name="offerCoverageToFireStationMorethan5Mi"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Can you offer coverage to  an owner with any exotic animals?"
                                           defaultValue={searchCriteria?.offerCoverageToOwnerOfExoticAnimals}
                                           value={searchCriteria?.offerCoverageToOwnerOfExoticAnimals} name="offerCoverageToOwnerOfExoticAnimals"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Can you offer coverage to an owner of any of the following breeds of dogs: German Shepherd, Pit Bull, Rottweiler, Wolf-hybrid or mix of these types?"
                                           defaultValue={searchCriteria?.offerCoverageToDogBreed}
                                           value={searchCriteria?.offerCoverageToDogBreed} name="offerCoverageToDogBreed"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <MUISwitch errors={errors}
                                           label="Can you offer coverage on a property where business or farming is conducted on premise?"
                                           defaultValue={searchCriteria?.offerCoverageToFarmingOrBusiness}
                                           value={searchCriteria?.offerCoverageToFarmingOrBusiness} name="offerCoverageToFarmingOrBusiness"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper style={{margin: 16}}>
                    <Box m={2} style={{paddingTop:15}}>
                        <Typography variant="h5" align="left" component="h2" gutterBottom>
                            Filter Details
                        </Typography>
                    </Box>
                    <Box m={3}>
                        <Grid container alignItems="flex-start" spacing={2} m={3}>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Filter Leads by</FormLabel>
                                    <RadioGroup row
                                                aria-label="locationSelect"
                                                name="controlled-radio-buttons-group"
                                                value={searchCriteria.filterLocation}
                                                onChange={handleLocationSelect}
                                    >
                                        <FormControlLabel value="FL" control={<Radio color="primary"/>}
                                                          label="All of Florida"/>
                                        <FormControlLabel value="County" control={<Radio color="primary"/>}
                                                          label="Filter by County"/>
                                        <FormControlLabel value="Zip" control={<Radio color="primary"/>}
                                                          label="Filter by ZIP"/>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {searchCriteria?.filterLocation === 'County' && <Grid item xs={12} sm={6} md={4}>
                                <MUIMultiSelect control={control} name="acceptableCounties" value={searchCriteria?.acceptableCounties}
                                                label="County" errors={errors}
                                                defaultValue={searchCriteria?.acceptableCounties} onFormChange={handleFormChange}
                                                dropdownValues={countyList}/>
                            </Grid>}
                            {searchCriteria?.filterLocation === 'Zip' && <Grid item xs={12} sm={6} md={4}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <MUIInput control={control} name="combinedZip" inputPrp={{maxLength: 5}}
                                              label="Zip Code"
                                              defaultValue={combinedZip}
                                              value={combinedZip}
                                              onInputChange={(event) => setCombinedZip(event.target.value)}
                                              errors={errors}></MUIInput>
                                    <Button variant="contained" style={{backgroundColor: "#3f51b5", color: "white"}}
                                            size="small" disableElevation onClick={addZipCode}>Add</Button>
                                </Stack><br/>
                                <div style={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
                                    <div style={{display:"flex", alignItems:"center", justifyContent:"flex-start", marginRight:"0.25rem"}}>
                                        Zip Codes:
                                    </div>
                                    {searchCriteria?.acceptableZipCodes.length > 0 ? searchCriteria.acceptableZipCodes.map((item, i) =>{
                                        return (
                                            <div style={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
                                                <div style={{marginRight:"0.25rem"}}>
                                                    {item}
                                                </div>
                                                <HighlightOffIcon
                                                    titleAccess={"Delete Zip"}
                                                    onClick={removeZipCode(item, i)}
                                                    style={{
                                                        width:"0.85rem",
                                                        marginRight: "0.70rem",
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </div>
                                        )
                                    }) : null}
                                </div>
                                <br/>
                                {zipError && <span className="errorMessage">{zipError}</span>}
                            </Grid>}
                            <Grid item xs={12} sm={6} md={4}></Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <Box component="span" justifyContent="flex-end" marginTop="8px" marginRight="8px" alignItems="flex-end"
                                     display="flex">
                                    <Button variant="contained" color="primary" name="btnCancel" onClick={() => {setSearchCriteria(Object.assign({},initState));setShowEditTile(false);}}>
                                        Cancel
                                    </Button>&nbsp;&nbsp;
                                    {!criteriaId &&
                                        <Button type="submit" variant="contained" color="primary" name="btnCreate">
                                            Create
                                        </Button>}
                                    {criteriaId &&
                                        <Button disabled={isUpdateDisabled} type="submit" variant="contained" color="primary" name="btnUpd">
                                            Update
                                        </Button>}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </form>
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="success">{snackBarMessage}</Alert>
            </Snackbar>

            <Snackbar open={openSnackBarError} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="error">{snackBarMessage}</Alert>
            </Snackbar>
        </section>
    );
}
